import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem2Ads1 = () =>{
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1X4Lr2KYUA2L5HcXbIfQFNAOkYF4vdIwH/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1S4fa5QE18wddNSN7gllhEwE1VpxCiFEs/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/ADS-1-2-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">ADS Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2Ads1